import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {BuGroupField, PageResponse} from "../../services/ApiTypes";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";

type Selection = SelectionResult<string>;

type Props = {
    field: BuGroupField
    label: string
}

export const SearchBuGroupAutocomplete: React.FC<Props> = observer(({field, label}) => {
    const {bagStore, materializedApi} = useStores();
    const selection: Selection = bagStore.advanced.filters[field] ?? DEFAULT;
    const filter = bagStore.advanced.filterQueryParamsBuGroup(field);
    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready)
            ? materializedApi.searchInsightBuGroups(bagStore.advanced.databagId, field, filter, search)
                .then<PageResponse<Option>>(resp => ({
                    count: resp.data.length,
                    next: '',
                    previous: '',
                    results: resp.data.map(({value, total_spend}) => ({
                        id: value,
                        label: value || '(Empty)',
                        subTotalSpend: Number(total_spend),
                        obj: {value, total_spend},
                    })),
                }))
            : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, field, filter]
    );
    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label={label}
        enableLabelStatus
        getOptions={getOptions}
        onSelectionChange={selection => bagStore.advanced.buGroupFilterChanged(field, selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />
})
